// extracted by mini-css-extract-plugin
export default {"primaryColor":"#1890ff","backColor":"#f0f2f5","buttonSpacing":"8px","textButtonSpacing":"4px","carTree":"carTree_carTree__IXaBW","title":"carTree_title__ot9ns","filterIcon":"carTree_filterIcon__QYdDK","tree":"carTree_tree__o722I"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"primaryColor\":\"#1890ff\",\"backColor\":\"#f0f2f5\",\"buttonSpacing\":\"8px\",\"textButtonSpacing\":\"4px\",\"carTree\":\"carTree_carTree__IXaBW\",\"title\":\"carTree_title__ot9ns\",\"filterIcon\":\"carTree_filterIcon__QYdDK\",\"tree\":\"carTree_tree__o722I\"}";
        // 1793842503984
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  